import { render, staticRenderFns } from "./CalendarTest.vue?vue&type=template&id=00dbc96e"
import script from "./CalendarTest.vue?vue&type=script&lang=js"
export * from "./CalendarTest.vue?vue&type=script&lang=js"
import style0 from "./CalendarTest.vue?vue&type=style&index=0&id=00dbc96e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports